import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import FormCertificationTemplate from './form-certification-template';
import { createMessage } from 'works/legacy/lib/message-helper';
import { CreateCertificationItemTemplate } from 'works/legacy/graphql/works-list-item-template';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export default function CreateCertificationTemplate({
  dismiss,
  worksListTemplateId,
  form,
}) {
  const handleMutationCompletion = (response) => {
    if (response.createCertificationItemTemplate.errors) {
      addErrorsToForm(form, response.createCertificationItemTemplate.errors);

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item created!');
      dismiss();
    }
  };

  const [createCertification] = useMutation(CreateCertificationItemTemplate, {
    onCompleted: handleMutationCompletion,
    onError: () =>
      createMessage(
        'error',
        'Failed to create Compliance Item. Please try again.'
      ),
  });

  const handleSubmit = (values) => {
    createCertification({
      variables: {
        worksListTemplateId: worksListTemplateId,
        input: values,
      },
    });
  };

  return (
    <FormCertificationTemplate
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      initialValues={{ active: true, expirationType: 'EXPIRATION_DATE' }}
      showExpiration
      form={form}
    />
  );
}

CreateCertificationTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  worksListTemplateId: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
};
